<div
  class="side-nav-menu-wrap m-t-20"
  data-test-id="snMenuListContainer"
  [ngClass]="{ resizeSideNavToggle: resizeSideNavToggle }"
>
  <mat-nav-list data-test-id="snMenuList">
    <cigna-canav-item
      [attr.data-test-id]="'snMenuItem'"
      [items]="items"
      [profileItems]="profileItems"
      [communicationItems]="communicationItems"
      [isInternalUser]="isInternalUser"
      [isFromBRPortal]="isFromBRPortal"
      [selectedClient]="selectedClient"
      [isBillpayEnabled]="isBillpayEnabled"
      [isBillpayFacetsEnabled]="isBillpayFacetsEnabled"
      [isGovNonFacetsEnabled]="isGovNonFacetsEnabled"
      [isGovFacetsEnabled]="isGovFacetsEnabled"
      [isIncentiveEnabled]="isIncentiveEnabled"
      [isCoverageTransparencyEnabled]="isCoverageTransparencyEnabled"
      [isEnableBankingNonFacets]="isEnableBankingNonFacets"
      [isEnableEligibilityNonFacets]="isEnableEligibilityNonFacets"
      [isEnableClaimsNonFacets]="isEnableClaimsNonFacets"
      [isEnableFundDrivenNonFacets]="isEnableFundDrivenNonFacets"
      [isEnableIcmsClient]="isEnableIcmsClient"
      [isArchvdRptEnalbed]="isArchvdRptEnalbed"
      [isCDBNewenrollEnabled]="isCDBNewenrollEnabled"
      [isFacetsNewenrollEnabled]="isFacetsNewenrollEnabled"
      [isLinkEnabled]="isLinkEnabled"
      [goToLink]="goToLink"
      [source]="source"
      [tools]="tools$ | async"
      (openExternalPage)="openExternal($event)"
      (navigateExternal)="navigateExternal($event)"
      (redirect)="redirect($event)"
      (goToCommercialCompStmt)="goToCommercialCompStmt()"
      (goToFundingSolution)="goToFundingSolution()"
      (goToSolutionsAndInsights)="goToSolutionsAndInsights()"
      (goToBookOfBusiness)="goToBookOfBusinessPage()"
      (goToSmallGroupRenewals)="goToSmallGroupRenewalsPage()"
      (goToMaCompensationPage)="goToMaCompensationPage()"
      (goToCSBIncentives)="goToCSBIncentives()"
      (closeMenuEmitter)="closeMenu()"
      [hasBoBMA]="hasBoBMA$ | async"
      [hasBoBMAInt]="hasBoBMAInt$ | async"
      [hasBoBMaApplicationStatusExt]="hasBoBMaApplicationStatusExt$ | async"
      [hasBoBMaApplicationStatusInt]="hasBoBMaApplicationStatusInt$ | async"
      [isImpersonatorFlag]="isImpersonatorFlag"
      [hasIfpAdminMenu]="hasIfpAdminMenu"
    ></cigna-canav-item>
  </mat-nav-list>
</div>

<form
  autocomplete="off"
  name="capreport"
  id="cap-reports"
  action="{{ sanitiseHhtmlProperty('CAP/') }}"
  method="POST"
>
  <input
    type="hidden"
    name="clientID"
    value="{{ sanitiseHhtmlProperty(selectedClientDetail?.id) }}"
  />
  <input
    type="hidden"
    name="clientName"
    value="{{ sanitiseHhtmlProperty(selectedClientDetail?.name) }}"
  />
</form>
<cigna-legal-affirmation-modal
  #legalAffirmationModal
  [agencyList]="agencyList$ | async"
  [isBackLink]="isBackLink"
  [isViewStatmtLink]="isViewStatmtLink"
  (submitLegalAffirm)="submitLegalAffirm($event)"
  [detailsError]="detailsErrorAppShared$ | async"
  [isLoadingAppShared]="loadingAppShared$ | async"
  [isPostAffirmFailed]="isPostAffirmFailed$ | async"
  [isGetAgencyFailed]="isGetAgencyFailed"
  [affirmResponse]="affirmResponse$ | async"
  [isImpersonatorFlag]="isImpersonatorFlag"
></cigna-legal-affirmation-modal>
